import { useParams } from 'react-router-dom'
import { IPageProps, IParamsType, AlertMessage, FormTypeEnum } from 'types'
import { Spinner } from 'components'
import { useEffect, useState } from 'react'
import { WebLeadFilterDto } from 'generated/v1/v1IntegrationsApi'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { getErrors } from 'core/helpers'
import WebsiteLeadsFilterForm from 'components/Integrations/WebsiteLeadsFilter/WebsiteLeadsFilterForm'

export interface IParams extends IParamsType {
    id: string
}

const WebsiteLeadsFilterEditPage = ({ title }: IPageProps) => {

    const { id } = useParams<IParams>()
    const [webLeadFilter, setWebLeadFilter] = useState<WebLeadFilterDto>()
    const [alert, setAlert] = useState<AlertMessage>()
    const [loaded, setLoaded] = useState(false)

    const fetchWebLeadsFilter = async () => {
        if (!id || !id.trim() || isNaN(Number(id))) {
            return
        }

        try {
            //await dispatch(startLoadingAction())
            setAlert({ variant: 'info', messages: [] })
            let webLead = await V1ApiIntegrationsClient.getWebLeadFilter(Number(id))
            setWebLeadFilter(webLead.payload)
            setLoaded(true)
        }
        catch (e) {
            setAlert({ variant: 'danger', messages: getErrors(e) })
        }
        finally {
            window.scrollTo(0, 0)
        }
    }

    const updateWebLeadFilter = async (webLeadFilter: WebLeadFilterDto) => {
        return V1ApiIntegrationsClient.updateWebLeadFilter(webLeadFilter)
    }

    useEffect(() => {
        fetchWebLeadsFilter()
    }, [id])

    if (!loaded)
        return <Spinner center={true} />

    return (
        <WebsiteLeadsFilterForm 
            title={title} 
            formType={FormTypeEnum.Edit} 
            initialValues={webLeadFilter} 
            AddOrUpdateWebLeadFilter = {updateWebLeadFilter}
        />
    )
}
export default WebsiteLeadsFilterEditPage
